import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvironmentFeatures } from '@era/app';
import { Device, DeviceType } from '@era/locations-sdk';
import { DeviceStoreSelectors, LocationSubset } from '@era/stores';
import { EnvironmentService } from '@methylium/core';
import { NgbDropdownButtonItem, NgbDropdownItem, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ContextMenuComponent } from '@rocksoft/cdk';
import { Observable } from 'rxjs';
import { RebootDevicesModalContainerComponent } from '../../sub-features/reboot-devices-modal/reboot-devices-modal.container';
import { DeviceGridComponent } from '../device-grid/device-grid.component';
import { DevicesSyncModalContainerComponent } from '../devices-sync-modal/devices-sync-modal.container';

@Component({
  selector: 'era-devices-staff',
  templateUrl: './devices-staff.container.html',
  styleUrls: ['./devices-staff.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DeviceGridComponent, ContextMenuComponent, NgbDropdownButtonItem, NgbDropdownItem, AsyncPipe],
})
export class DevicesStaffContainerComponent {
  public readonly features: EnvironmentFeatures;
  public readonly staffDevices$: Observable<Device[]>;
  public readonly staffDevicesCount$: Observable<number>;

  constructor(
    private readonly deviceStore: Store<Device>,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly environmentService: EnvironmentService,
    private readonly modalService: NgbModal
  ) {
    this.features = this.environmentService.environment.features;
    this.staffDevices$ = this.deviceStore.select(DeviceStoreSelectors.selectCurrentLocationStaffDevices);

    this.staffDevicesCount$ = this.deviceStore.select(DeviceStoreSelectors.selectCurrentLocationStaffDevicesCount);
  }

  public itemSelected(device: Device) {
    if (device.deviceType === DeviceType.Apple) {
      void this.router.navigate(['apple', device.deviceId], { relativeTo: this.route });
    }
  }

  public openRebootRequest() {
    const modal = this.modalService.open(RebootDevicesModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.Staff;
  }

  public openSyncModalRequest() {
    const modal = this.modalService.open(DevicesSyncModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.Staff;
  }
}
